import { observable } from 'mobx';

const CustomerListModel = observable({
    columns : [],
    setColumns(columns) {
        this.columns = columns || []
    }
});

export default CustomerListModel;